export const INITIAL_STATE = {
    email: '',
    password: '',
    mobileNumber: '',
    selectedRole: '',
    loading: false,
    error: '',
    success: false,
    validated: false,
    fieldErrors: {},
};

export const SUCCESS_MESSAGE = 'User signed up successfully!';

export const TOAST_MESSAGES = {
    success: 'User Added Successfully!',
    error: 'Failed to add user. Please try again.',
};

export const API_ERROR_MESSAGES = {
    EMAIL_ALREADY_EXISTS: 'Email already exists.',
};

export const VALIDATION_ERROR_MESSAGES = {
    email: 'Please provide a valid email address.',
    password: 'Password must be at least 8 characters long.',
    mobileNumber: 'Please provide a valid mobile number (10 digits).',
    selectedRole: 'Role selection is required.',
};

export const USER_ROLES = [
    {
        id: 'ROLE_LOYALTY_SUPER_ADMIN',
        name: 'Super Admin',
    },
    {
        id: 'ROLE_LOYALTY_ADMIN',
        name: 'Admin',
    },
    {
        id: 'ROLE_LOYALTY_VIEWER',
        name: 'Viewer',
    },
];

export const ADD_USER_FORM_FIELDS = [
    {
        name: 'email',
        label: 'Email Address',
        type: 'email',
        placeholder: 'Enter email address',
        required: true,
        validationMessage: 'Please provide a valid email address.',
    },
    {
        name: 'password',
        label: 'Password',
        type: 'text',
        placeholder: 'Enter password (minimum 8 characters)',
        required: true,
        validationMessage: 'Password must be at least 8 characters long.',
    },
    {
        name: 'mobileNumber',
        label: 'Mobile Number',
        type: 'tel',
        placeholder: 'Enter mobile number',
        required: true,
        validationMessage: 'Please provide a valid mobile number (10 digits).',
    },
];
